module.exports = __webpack_public_path__ + "static/media/logo-stichting-ik-wil.93b14e7c.svg";